import {createStyles, Theme} from "@material-ui/core";
import {styleColors} from "src/main.style";

const hiddenVideoControlsSelector = [
  "#myvideo::-webkit-media-controls-play-button",
  "#myvideo::-webkit-media-controls-start-playback-button",
  "#myvideo::-webkit-media-controls-overlay-play-button",
  "#myvideo::-webkit-media-controls-enclosure",
  "#videochat::-webkit-media-controls-play-button",
  "#videochat::-webkit-media-controls-start-playback-button",
  "#videochat::-webkit-media-controls-overlay-play-button",
  "#videochat::-webkit-media-controls-enclosure",
].join(", ");

/* The call screen has a fixed dark-on-black aesthetic — same in both
   themes. Surfaces and text use literal black/white instead of theme
   tokens (which would flip in dark mode and break the look). */
const CALL_BLACK = "#000000";
const CALL_WHITE = "#FFFFFF";
const CALL_TILE_GREY = "#222222";
const CALL_SHADOW = "rgba(0, 0, 0, 0.45)";
const CALL_TEXT_SHADOW = "rgba(0, 0, 0, 0.63)";
const CALL_WHITE_OVERLAY_28 = "rgba(255, 255, 255, 0.28)";
const CALL_WHITE_TEXT_82 = "rgba(255, 255, 255, 0.82)";

export const ConnecycubeStyle = (theme: Theme) => createStyles({
  "@global": {
    [hiddenVideoControlsSelector]: {
      display: "none !important",
      WebkitAppearance: "none",
      opacity: "0 !important",
    },
    "#myvideo, #videochat": {
      backgroundColor: `${CALL_BLACK} !important`,
    },
  },
  callInfo: {
    position: 'absolute',
    width: 'calc(100% - 60px)',
    left: '30px',
    top: '100px',
    color: CALL_WHITE,
    textAlign: 'center',
    fontSize: '22px',
    zIndex: 2000,
    display: 'flex',
    flexDirection: 'column',
  },
  answerButton: {
    position: 'absolute',
    width: '70px',
    right: '30px',
    bottom: '30px',
    backgroundColor: styleColors.callGreen,
    zIndex: 2000,
    height: '70px',
    borderRadius: '100px',
    boxShadow: `0px 3px 10px ${CALL_SHADOW}`,
    display: 'flex',
  },
  answerButtonDisabled: {
    backgroundColor: CALL_WHITE_OVERLAY_28,
    boxShadow: `0px 3px 10px ${CALL_SHADOW}`,
  },
  denyButton: {
    position: 'absolute',
    width: '70px',
    left: '30px',
    bottom: '30px',
    backgroundColor: styleColors.callRed,
    zIndex: 2000,
    height: '70px',
    borderRadius: '100px',
    boxShadow: `0px 3px 10px ${CALL_SHADOW}`,
    display: 'flex',
  },
  answerButtonStatus: {
    position: 'absolute',
    right: '22px',
    bottom: '118px',
    width: '86px',
    color: CALL_WHITE_TEXT_82,
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: 1.4,
    zIndex: 2000,
    textShadow: `0px 1px 3px ${CALL_TEXT_SHADOW}`,
    pointerEvents: 'none',
  },
  callRecordingNotice: {
    position: 'absolute',
    width: 'calc(100% - 80px)',
    left: '40px',
    bottom: '118px',
    color: CALL_WHITE_TEXT_82,
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: 1.4,
    zIndex: 2000,
    textShadow: `0px 1px 3px ${CALL_TEXT_SHADOW}`,
    pointerEvents: 'none',
  },
  backdrop : {
    minHeight:'100%',
    minWidth:'100%',
    position:'absolute',
    top:0,
    left:0,
    backgroundColor: CALL_BLACK,
    opacity:1,
    zIndex: 1500,
    transition: 'opacity 0.5s ease-out',
  },
  videoChat: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '30%',
    backgroundColor: CALL_TILE_GREY,
    zIndex: 1600,
    transition: 'all 0.5s ease-out',
  },
  videoChatVideo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundColor: CALL_BLACK,
  },
  videoWall: {
    height: '100%',           /* full screen */
    width: '100%',
    display: 'grid',
    gap: 0,

    // Base (1 video → full screen)
    gridTemplateRows: '1fr',
    gridTemplateColumns: '1fr',

    // Make children + videos fill their cells
    '& > *': {
      width: '100%',
      height: '100%',
      display: 'block',
      overflow: 'hidden',
      backgroundColor: CALL_BLACK,
    },

    // Pure-CSS layout switching based on child count
    '@supports selector(:has(*))': {
      // Exactly 2 videos → top / bottom
      '&:has(> :nth-child(2)):not(:has(> :nth-child(3)))': {
        gridTemplateRows: 'repeat(2, 1fr)',
        gridTemplateColumns: '1fr',
      },
      // Exactly 3 videos → top / middle / bottom
      '&:has(> :nth-child(3)):not(:has(> :nth-child(4)))': {
        gridTemplateRows: 'repeat(3, 1fr)',
        gridTemplateColumns: '1fr',
      },
      // 4 or more videos → 2x2 (TL, TR, BL, BR)
      '&:has(> :nth-child(4))': {
        gridTemplateRows: 'repeat(2, 1fr)',
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
    },
  }
});



// WEBPACK FOOTER //
// ./src/components/calls/connectycube.style.ts